import { sectionsOf } from "@/lib/reportSection";

import { tr } from "@/lib/i18n";
const DEFAULTS = { plan: true, plan_bg: "auto", plan_dims: true, plan_group_dims: true, section: true, section_dims: true, layout: true, zones: true };

export const reportOpts = (p) => ({ ...DEFAULTS, ...(p.report || {}) });

const Check = ({ label, checked, onChange, testid, disabled, hint }) => (
  <label className={`flex items-start gap-2 text-sm ${disabled ? "opacity-50" : "cursor-pointer"}`}>
    <input type="checkbox" className="mt-1 accent-[#0F52BA]" checked={checked && !disabled} disabled={disabled} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
    <span>{label}{hint && <span className="block text-xs text-slate-400">{hint}</span>}</span>
  </label>
);

const Sel = ({ value, onChange, testid, children, disabled }) => (
  <select value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className="h-8 px-2 text-xs border border-slate-200 rounded bg-white disabled:opacity-50">{children}</select>
);

// scelta delle viste da includere nel PDF e delle loro quote
export const ReportOptions = ({ p, update, layout }) => {
  const o = reportOpts(p);
  const set = (patch) => update((prev) => ({ report: { ...reportOpts(prev), ...patch } }));
  const hasPhoto = !!(p.background?.file_id && p.background?.px);
  const falde = layout.fields.filter((f) => f.active.length);
  const secs = sectionsOf(layout);
  return (
    <div className="grid md:grid-cols-2 gap-x-8 gap-y-4" data-testid="report-options">
      <div className="space-y-2">
        <Check label={tr("Pianta su foto con moduli e struttura")} checked={o.plan} onChange={(v) => set({ plan: v })} testid="report-opt-plan" hint={tr("A4 orizzontale, una pagina per il progetto")} />
        <div className="pl-6 flex flex-wrap items-center gap-2 text-xs text-slate-500">
          {tr("Sfondo")}
          <Sel value={hasPhoto ? o.plan_bg : "satellite"} onChange={(v) => set({ plan_bg: v })} testid="report-opt-plan-bg" disabled={!o.plan}>
            <option value="auto" disabled={!hasPhoto}>{tr("Foto da drone (se presente)")}</option>
            <option value="satellite">{tr("Mappa satellitare")}</option>
          </Sel>
          {!hasPhoto && <span>{tr("nessuna foto georeferenziata")}</span>}
        </div>
        <div className="pl-6"><Check label={tr("Quote: lati delle falde e distanza minima moduli-bordo")} checked={o.plan_dims} onChange={(v) => set({ plan_dims: v })} testid="report-opt-plan-dims" disabled={!o.plan} /></div>
        <div className="pl-6"><Check label={layout.flat ? tr("Quote delle file di moduli (lunghezza, n° moduli) e spazio libero tra le file") : tr("Quote dei gruppi di moduli (larghezza, lunghezza lungo falda, righe × colonne)")} checked={o.plan_group_dims} onChange={(v) => set({ plan_group_dims: v })} testid="report-opt-plan-group-dims" disabled={!o.plan} /></div>
      </div>
      <div className="space-y-2">
        <Check label={tr("Sezione della falda perpendicolare alla gronda")} checked={o.section} onChange={(v) => set({ section: v })} testid="report-opt-section" disabled={layout.flat || !falde.length}
          hint={layout.flat ? tr("solo per tetti a falda") : tr("misure lungo falda in scala, altezze schematiche")} />
        {!layout.flat && <div className="pl-6 text-xs text-slate-500" data-testid="report-opt-section-list">
          {secs.length
            ? <>{tr("Una pagina per ogni linea di sezione:")} {secs.map((x) => <b key={x.letter} className="text-slate-700">{x.letter}–{x.letter} ({x.f.roof.name}) </b>)}</>
            : tr("Nessuna linea di sezione disegnata: sezione nel mezzo del campo della prima falda con moduli. Traccia le linee al passo Bozza moduli con lo strumento \"Linea di sezione\".")}
        </div>}
        <div className="pl-6"><Check label={tr("Quote lungo falda (gronda, moduli, colmo, binari)")} checked={o.section_dims} onChange={(v) => set({ section_dims: v })} testid="report-opt-section-dims" disabled={!o.section || layout.flat} /></div>
      </div>
      <Check label={tr("Layout schematico dei campi moduli")} checked={o.layout} onChange={(v) => set({ layout: v })} testid="report-opt-layout" />
      <Check label={tr("Zone di carico vento")} checked={o.zones} onChange={(v) => set({ zones: v })} testid="report-opt-zones" />
    </div>
  );
};
